/* eslint-disable */
import React from "react";
import { Card } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import HistoryList from "../includes/HistoryList";
import Engine from "../Engine";
import { Game } from "../../../../Helper";

class Canvas extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
    this.isStopGame = React.createRef();
    this.isStopGame.current = true;
    this.gameISStarted = React.createRef();
    this.gameISStarted.current = false;
    this.theme = "crash_them";
    this.engine = Engine;
    this.FPS = /Mobi|Android/i.test(navigator.userAgent) ? 30 : 60;
    this.startTime = null;
    this.waitStartTime = null;
    this.rotationAngle = 0;

    this.state = {
      imagesLoaded: false,
      loadingError: null,
      engine: Engine,
      connecting: true,
      hash: null,
      status: "",
      timer: "",
      rate: "",
      inPlay: true,
      current_amount: "1.00",
      startedTime: 0,
      timePassed: 0,
      isWaitingBeforeCountdown: false,
      showBustTextUntilWaiting: false,
    };

    this.imageRef = {
      plan1: new Image(),
      plan2: new Image(),
      plan3: new Image(),
      plan4: new Image(),
      imagePath: null,
      imgName: 1,
      interval: null,
    };

    this.animationRef = {
      planRunningFram: null,
      planRunningCrashFram: null,
      oscillationInterval: null,
      waitFrame: null,
    };

    this.animationState = {
      x0: 0,
      y0: 676,
      x1: 405,
      y1: 608,
      x2: 1040,
      y2: 208,
      progress: 0,
      oscillationPhase: 0,
    };

    this.getPlan = this.getPlan.bind(this);
    this.updateImage = this.updateImage.bind(this);
    this.clearAnimationData = this.clearAnimationData.bind(this);
    this.lerp = this.lerp.bind(this);
    this.drawBezierSplit = this.drawBezierSplit.bind(this);
    this.planCrashAnimation = this.planCrashAnimation.bind(this);
    this.planEnd = this.planEnd.bind(this);
    this.oscillateGraph = this.oscillateGraph.bind(this);
    this.animatePathDrawing = this.animatePathDrawing.bind(this);
    this.startCrashAnimation = this.startCrashAnimation.bind(this);
    this.drawWaiting = this.drawWaiting.bind(this);
    this.finish = this.finish.bind(this);
    this.waiting = this.waiting.bind(this);
    this.started = this.started.bind(this);
    this.busted = this.busted.bind(this);
    this.status = this.status.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    const canvas = this.canvasRef.current;
    if (!canvas) {
      console.log('componentDidMount: Canvas ref is null or undefined');
      return;
    }

    const ctx = canvas.getContext("2d");
    canvas.width = 1450;
    canvas.height = 676;

    const { plan1, plan2, plan3, plan4 } = this.imageRef;
    let loadedCount = 0;

    const onImageLoad = (img) => {
      loadedCount++;
      console.log(`Image loaded: ${img.src}, Loaded count: ${loadedCount}`);
      if (loadedCount === 4) {
        this.imageRef.imagePath = plan1;
        this.setState({ imagesLoaded: true, loadingError: null });
        console.log('All images loaded successfully');
      }
    };

    const onImageError = (e) => {
      const errorMsg = `Image loading failed: ${e.target.src}`;
      console.error(errorMsg);
      this.setState({ loadingError: errorMsg });
    };

    if (this.theme === "crash_theme") {
      plan1.src = "/assets/images/plan01-green.png";
      plan2.src = "/assets/images/plan02-green.png";
      plan3.src = "/assets/images/plan03-green.png";
      plan4.src = "/assets/images/fan-load-green.svg";
    } else {
      plan1.src = "/assets/images/plan01-orange.png";
      plan2.src = "/assets/images/plan02-orange.png";
      plan3.src = "/assets/images/plan03-orange.png";
      plan4.src = "/assets/images/fan-load-orange.svg";
    }

    plan1.onload = () => onImageLoad(plan1);
    plan2.onload = () => onImageLoad(plan2);
    plan3.onload = () => onImageLoad(plan3);
    plan4.onload = () => onImageLoad(plan4);

    plan1.onerror = onImageError;
    plan2.onerror = onImageError;
    plan3.onerror = onImageError;
    plan4.onerror = onImageError;

    setTimeout(() => {
      if (this._isMounted && !this.state.imagesLoaded) {
        console.log('Images not loaded after 5 seconds. Loaded count:', loadedCount);
      }
    }, 5000);

    this.engine.trigger.on("finish_crash", (data) => this.finish(data));
    this.engine.trigger.on("waiting_crash", (data) => this.waiting(data));
    this.engine.trigger.on("started_crash", (data) => this.started(data));
    this.engine.trigger.on("busted_crash", (data) => this.busted(data));
    this.engine.trigger.on("game_status", (data) => this.status(data));
  }

  componentWillUnmount() {
    this._isMounted = false;
    cancelAnimationFrame(this.animationRef.planRunningFram);
    cancelAnimationFrame(this.animationRef.planRunningCrashFram);
    cancelAnimationFrame(this.animationRef.waitFrame);
    clearInterval(this.animationRef.oscillationInterval);
    this.clearAnimationData();
  }

  getPlan() {
    const { imgName, plan1, plan2, plan3 } = this.imageRef;
    if (imgName === 1) {
      this.imageRef.imgName = 2;
      this.imageRef.imagePath = plan2;
    } else if (imgName === 2) {
      this.imageRef.imgName = 3;
      this.imageRef.imagePath = plan3;
    } else {
      this.imageRef.imgName = 1;
      this.imageRef.imagePath = plan1;
    }
  }

  updateImage() {
    if (!this.imageRef.interval) {
      this.imageRef.interval = setInterval(() => this.getPlan(), 150);
    }
  }

  clearAnimationData() {
    const canvas = this.canvasRef.current;
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }

    clearInterval(this.animationRef.oscillationInterval);
    clearInterval(this.imageRef.interval);
    cancelAnimationFrame(this.animationRef.planRunningFram);
    cancelAnimationFrame(this.animationRef.planRunningCrashFram);
    cancelAnimationFrame(this.animationRef.waitFrame);

    this.imageRef.interval = null;
    this.animationRef.oscillationInterval = null;
    this.startTime = null;
    this.waitStartTime = null;
    this.rotationAngle = 0;
    this.animationState.progress = 0;
    this.animationState.oscillationPhase = 0;
  }

  lerp(v0, v1, t) {
    return (1.0 - t) * v0 + t * v1;
  }

  drawBezierSplit(ctx, x0, y0, x1, y1, x2, y2, t0, t1) {
    if (!this.state.imagesLoaded) {
      console.log('drawBezierSplit: Images not loaded, drawing multiplier only');
    } else {
      const canvasWidth = ctx.canvas.width;
      const canvasHeight = ctx.canvas.height;
      const imageWidth = 238;
      const imageHeight = 128;

      ctx.save();
      ctx.beginPath();
      const image = this.imageRef.imagePath;

      if (!image || !image.complete || image.naturalWidth === 0) {
        console.log('drawBezierSplit: Invalid image, skipping image draw');
      } else {
        x0 = Math.max(0, Math.min(x0, canvasWidth));
        y0 = Math.max(0, Math.min(y0, canvasHeight));
        x1 = Math.max(0, Math.min(x1, canvasWidth));
        y1 = Math.max(0, Math.min(y1, canvasHeight));
        x2 = Math.max(0, Math.min(x2, canvasWidth - imageWidth));
        y2 = Math.max(imageHeight, Math.min(y2, canvasHeight));

        if (t0 === 0.0 && t1 === 1.0) {
          ctx.moveTo(x0, y0 + 2);
          ctx.drawImage(image, x2 - 35, y2 - 109, imageWidth, imageHeight);
          ctx.quadraticCurveTo(x1, y1, x2, y2);
          ctx.stroke();
          ctx.lineTo(x2, y0 + 20);
          ctx.fillStyle = this.theme === "crash_theme" ? "#4da300" : "#f27b42";
          ctx.fill();
        } else if (t0 !== t1) {
          const t00 = t0 * t0,
            t01 = 1.0 - t0,
            t02 = t01 * t01,
            t03 = 2.0 * t0 * t01;
          const nx0 = t02 * x0 + t03 * x1 + t00 * x2,
            ny0 = t02 * y0 + t03 * y1 + t00 * y2;

          const t10 = t1 * t1,
            t11 = 1.0 - t1,
            t12 = t11 * t11,
            t13 = 2.0 * t1 * t11;
          const nx2 = t12 * x0 + t13 * x1 + t10 * x2,
            ny2 = t12 * y0 + t13 * y1 + t10 * y2;

          const nx1 = this.lerp(this.lerp(x0, x1, t0), this.lerp(x1, x2, t0), t1),
            ny1 = this.lerp(this.lerp(y0, y1, t0), this.lerp(y1, y2, t0), t1);

          ctx.lineWidth = 10;
          ctx.strokeStyle = this.theme === "crash_theme" ? "#74f700" : "#fb6a25";
          ctx.moveTo(nx0, ny0 + 2);
          ctx.drawImage(image, nx2 - 35, ny2 - 109, imageWidth, imageHeight);
          ctx.quadraticCurveTo(nx1, ny1, nx2, ny2);
          ctx.stroke();
          ctx.lineTo(nx2, ny0 + 20);
          ctx.fillStyle = this.theme === "crash_theme" ? "#74f700" : "#fb6a25";
          ctx.fill();
        }
      }
      ctx.restore();
      ctx.closePath();
    }

    if (this.state.status === "started") {
      const timePassed = this.state.startedTime ? ((new Date).getTime() - this.state.startedTime) : 0;
      const currentAmount = Math.max(1.00, Math.pow(Math.E, 6e-5 * timePassed)).toFixed(2);

      // console.log(`Updating multiplier: ${currentAmount}, TimePassed: ${timePassed}, Status: ${this.state.status}`);

      this.setState({ current_amount: currentAmount });
      Game["current_amount"] = currentAmount;

      ctx.font = "bolder 92px Arial";
      ctx.fillStyle = this.theme === "crash_theme" ? "#00ff00" : "#ffffff";
      ctx.textAlign = "center";
      ctx.fillText(`${currentAmount}x`, ctx.canvas.width / 2, ctx.canvas.height / 2);
    }
  }

  planCrashAnimation(ctx, x, y, progress) {
    if (!this.state.imagesLoaded) return;

    const canvasWidth = ctx.canvas.width;
    const canvasHeight = ctx.canvas.height;
    const imageWidth = 238;
    const imageHeight = 128;

    ctx.save();
    const image = this.imageRef.imagePath;
    if (!image || !image.complete || image.naturalWidth === 0) return;

    const nx = x + progress * canvasWidth * 2;
    const ny = y - progress * 1000;
    ctx.drawImage(image, nx - 35, ny - 109, imageWidth, imageHeight);
    ctx.restore();
  }

  planEnd(ctx, x0, y0, x1, y1, x2, y2, a, progress) {
    const animationDuration = 4000;
    const delayBeforeWaiting = 2000;
    let startTime = null;

    const step = (timestamp) => {
      if (!this._isMounted) return;

      if (startTime === null) startTime = timestamp;
      const elapsed = timestamp - startTime;

      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

      if (elapsed < animationDuration) {
        this.animationState.progress = elapsed / animationDuration;
        this.planCrashAnimation(ctx, x2, y2, this.animationState.progress);
      }

      if (this.state.showBustTextUntilWaiting && this.state.rate) {
        ctx.textAlign = "center";
        ctx.font = "bold 34px Arial";
        ctx.fillStyle = this.theme === "crash_theme" ? "#f27b42" : "#f27b42";
        ctx.fillText("FLEW AWAY!", ctx.canvas.width / 2, ctx.canvas.height / 2 - 10);

        ctx.font = "bold 78px Arial";
        ctx.fillText(`${this.state.rate} X`, ctx.canvas.width / 2, ctx.canvas.height / 2 + 80);
      }

      if (elapsed < animationDuration) {
        this.animationRef.planRunningCrashFram = requestAnimationFrame(step);
      } else if (elapsed < animationDuration + delayBeforeWaiting) {
        this.animationRef.planRunningCrashFram = requestAnimationFrame(step);
      } else {
        this.clearAnimationData();
        this.gameISStarted.current = false;
        this.isStopGame.current = true;
        this.setState({ isWaitingBeforeCountdown: true, showBustTextUntilWaiting: false }, () => {
          if (this.state.status === "busted" && this.state.isWaitingBeforeCountdown) {
            this.setState({ isWaitingBeforeCountdown: false });
            this.drawWaiting(ctx);
          }
        });
      }
    };

    this.animationRef.planRunningCrashFram = requestAnimationFrame(step);
  }

  oscillateGraph(ctx, x0, y0, x1, y1, x2, y2, a, progress) {
    if (!this._isMounted) return;

    const amplitude = 100;
    const baseY = 300;
    const frequency = 0.01;

    const initialOffset = y2 - baseY;
    this.animationState.oscillationPhase = Math.asin(initialOffset / amplitude);

    this.animationRef.oscillationInterval = setInterval(() => {
      if (!this._isMounted) {
        clearInterval(this.animationRef.oscillationInterval);
        return;
      }

      x2 = Math.max(0, Math.min(x2 + 1, ctx.canvas.width - 238));
      const multiplier = parseFloat(this.state.current_amount);

      this.animationState.oscillationPhase += frequency;
      const oscillation = Math.sin(this.animationState.oscillationPhase) * amplitude;
      y2 = Math.max(128, Math.min(baseY + oscillation - (multiplier / 50), ctx.canvas.height));

      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

      if (!this.isStopGame.current) {
        clearInterval(this.animationRef.oscillationInterval);
        this.planEnd(ctx, x0, y0, x1, y1, x2, y2, 0, this.animationState.progress);
      } else {
        this.drawBezierSplit(ctx, x0, y0, x1, y1, x2, y2, 0, 1);
      }
    }, 1000 / this.FPS);
  }

  animatePathDrawing(ctx, x0, y0, x1, y1, x2, y2, duration) {
    let start = null;

    const step = (timestamp) => {
      if (!this._isMounted || !this.canvasRef.current) return;

      if (start === null) start = timestamp;
      const delta = timestamp - start;
      this.animationState.progress = Math.min(delta / duration, 1);

      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

      // console.log(`Animating path, Progress: ${this.animationState.progress}, Status: ${this.state.status}`);

      if (!this.isStopGame.current || this.state.status === "busted") {
        this.planEnd(ctx, x0, y0, x1, y1, x2, y2, 0, this.animationState.progress);
      } else {
        this.drawBezierSplit(ctx, x0, y0, x1, y1, x2, y2, 0, this.animationState.progress);
        if (this.animationState.progress < 1) {
          this.animationRef.planRunningFram = requestAnimationFrame(step);
        } else {
          this.oscillateGraph(ctx, x0, y0, x1, y1, x2, y2, 0, this.animationState.progress);
        }
      }
    };

    this.animationRef.planRunningFram = requestAnimationFrame(step);
  }

  drawWaiting(ctx) {
    const canvas = this.canvasRef.current;
    if (!canvas || !this.state.imagesLoaded || this.gameISStarted.current) {
      console.log('drawWaiting aborted: Invalid canvas, images not loaded, or game already started');
      return;
    }

    let lastFrameTime = null;

    const step = (timestamp) => {
      if (!this._isMounted || (this.state.status !== "waiting" && !this.state.isWaitingBeforeCountdown)) {
        cancelAnimationFrame(this.animationRef.waitFrame);
        return;
      }

      if (lastFrameTime && (timestamp - lastFrameTime < 1000 / this.FPS)) {
        this.animationRef.waitFrame = requestAnimationFrame(step);
        return;
      }
      lastFrameTime = timestamp;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const image = this.imageRef.plan4;
      const imageWidth = 150;
      const imageHeight = 150;
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2 - 100;

      ctx.save();
      ctx.translate(centerX, centerY);
      this.rotationAngle += 0.05;
      ctx.rotate(this.rotationAngle);
      ctx.drawImage(image, -imageWidth / 2, -imageHeight / 2, imageWidth, imageHeight);
      ctx.restore();

      ctx.font = "bold 48px Arial";
      ctx.fillStyle = "#FFFFFF";
      ctx.textAlign = "center";

      if (this.state.isWaitingBeforeCountdown) {
        ctx.fillText("Waiting for next round", canvas.width / 2, canvas.height / 2 + 60);
      } else if (this.state.status === "waiting" && this.waitStartTime) {
        const waitTime = Math.max(0, (this.waitStartTime - (new Date).getTime()) / 1000);
        const timer = waitTime <= 0 ? "0.0" : waitTime.toFixed(1);
        ctx.fillText(
          waitTime <= 0 ? "please Wait..." : `Next round in ${timer}s`,
          canvas.width / 2,
          canvas.height / 2 + 60
        );
        //  ctx.fillText(`Next round in ${timer}s`,canvas.width / 2,canvas.height / 2 + 60);

        // console.log(`Countdown: ${timer}s, Status: ${this.state.status}, GameStarted: ${this.gameISStarted.current}`);
      }

      this.animationRef.waitFrame = requestAnimationFrame(step);
    };

    this.animationRef.waitFrame = requestAnimationFrame(step);
  }

  startCrashAnimation() {
    const canvas = this.canvasRef.current;

    const ctx = canvas.getContext("2d");
    this.gameISStarted.current = true;
    this.clearAnimationData();
    this.updateImage();
    this.isStopGame.current = true;
    this.startTime = (new Date).getTime();
    this.setState(
      {
        current_amount: "1.00",
        isWaitingBeforeCountdown: false,
        showBustTextUntilWaiting: false,
        status: "started",
        startedTime: (new Date).getTime(),
      },
      () => {
        // console.log('startCrashAnimation: State updated, starting animation');

        Game["current_amount"] = "1.00";
        canvas.width = 1450;
        canvas.height = 676;
        this.animatePathDrawing(ctx, 0, 676, 405, 608, 1040, 208, 4000);
      }
    );
  }

  finish(data) {
    if (this._isMounted) {
      let { name } = data;
      // console.log('Canvas finish_crash:', data, 'Timestamp:', (new Date).getTime());
    }
  }

  waiting(data) {
    if (this._isMounted) {
      // console.log('Canvas waiting_crash:', data, 'Timestamp:', (new Date).getTime());

      let { time } = data;
      this.setState({
        status: "waiting",
        inPlay: false,
        timer: time,
        startedTime: 0,
        timePassed: 0,
        isWaitingBeforeCountdown: false,
        showBustTextUntilWaiting: false,
      });
      Game["current_amount"] = "1.00";
      this.clearAnimationData();
      this.waitStartTime = (new Date).getTime() + time;

      // console.log(`waitStartTime set to: ${this.waitStartTime}`);

      this.gameISStarted.current = false;
      const canvas = this.canvasRef.current;
      if (canvas) this.drawWaiting(canvas.getContext("2d"));
    }
  }

  started(data) {
    if (this._isMounted) {
      // console.log('Received started_crash event:', data, 'Current Status:', this.state.status, 'GameStarted:', this.gameISStarted.current);

      let { time, md5 } = data;
      if (this.state.status !== "started" && !this.gameISStarted.current) {
        this.gameISStarted.current = true;
        this.setState(
          {
            status: "started",
            inPlay: true,
            timer: time,
            startedTime: (new Date).getTime() - time,
            timePassed: time,
            rate: "",
            isWaitingBeforeCountdown: false,
            showBustTextUntilWaiting: false,
          },
          () => {
            console.log('started: Initiating game animation', (new Date).getTime());
            Game["current_amount"] = "1.00";
            this.startCrashAnimation();
          }
        );
      } else {
        console.log('Ignoring started_crash: Game already started or in progress');
      }
    }
  }

  busted(data) {
    if (this._isMounted) {
      // console.log('Canvas busted_crash:', data, 'Timestamp:', (new Date).getTime());
      let { amount, time, force } = data;
      let rate = (amount / 100).toFixed(2);
      this.setState({
        status: "busted",
        inPlay: false,
        rate: rate,
        timer: time,
        current_amount: rate,
        startedTime: (new Date).getTime() - time,
        timePassed: time,
        showBustTextUntilWaiting: true,
      }, () => {
        this.isStopGame.current = false;
      });
      Game["current_amount"] = rate;
    }
  }

  status(data) {
    if (this._isMounted) {
      console.log('Canvas game_status:', data, 'Timestamp:', (new Date).getTime());
      let { amount, time, md5, status } = data;
      let rate = status === "busted" ? (amount / 100).toFixed(2) : this.state.rate;
      this.setState(
        {
          status: status,
          timer: time,
          connecting: false,
          rate: rate,
          current_amount: status === "busted" ? rate : this.state.current_amount,
          startedTime:
            status === "started" ? (new Date).getTime() - time :
              status === "busted" ? (new Date).getTime() - time : this.state.startedTime,
          timePassed: status === "started" || status === "busted" ? time : this.state.timePassed,
          isWaitingBeforeCountdown: status === "busted" ? this.state.isWaitingBeforeCountdown : false,
          showBustTextUntilWaiting: status === "busted" ? true : this.state.showBustTextUntilWaiting,
        },
        () => {
          if (status === "busted") {
            Game["current_amount"] = rate;
            this.isStopGame.current = false;
          } else if (status === "started" && !this.gameISStarted.current) {
            console.log('status: Initiating game animation for started status', (new Date).getTime());
            this.startCrashAnimation();
          } else if (status === "waiting") {
            this.waitStartTime = (new Date).getTime() + time;
            console.log(`waitStartTime set to: ${this.waitStartTime}`);
            const canvas = this.canvasRef.current;
            if (canvas) this.drawWaiting(canvas.getContext("2d"));
          }
        }
      );
    }
  }

  render() {
    const { t } = this.props;
    const { imagesLoaded, loadingError } = this.state;

    return (
      <Card className="no-shadow mb-0 game-wrapper-card game-chart-black-animation">
        <Card.Body className="bg-body text-center no-shadow pt-2 static-snow p-0" id="canvasPart">
          <div className="game-holder">
            <Card className="mb-0 bg-transparent">
              <Card.Body className="pt-0" style={{ padding: 0 }}>
                <div className="history_">
                  <HistoryList game="crash" t={t} />
                </div>
                <canvas ref={this.canvasRef} style={{ maxWidth: "100%", height: "auto" }} />
                {loadingError && (
                  <div style={{ color: "red", marginTop: "10px" }}>{loadingError}</div>
                )}
              </Card.Body>
            </Card>
          </div>
        </Card.Body>
      </Card>
    );
  }
}

Canvas.propTypes = {
  profit: PropTypes.string,
  im_in_game: PropTypes.bool,
  t: PropTypes.func,
};

const mapStateToProps = (state) => ({
  profit: state.items.profit,
  im_in_game: state.items.im_in_game,
});

export default connect(mapStateToProps, {})(Canvas);